import React from 'react';
import {
  Center,
} from 'ui';

export const Sandbox = () => (
  <Center />
);
